import React from 'react';
import PropTypes from 'prop-types';

import LoadingIndicator from 'components/loading-indicator';

const SkeletonLayout = () => (
  <div style={{ minHeight: '100vh', height: '100vh' }}>
    <LoadingIndicator className='pt-4 m-auto' style={{ height: '100vh', flex: 1 }} />;
  </div>
);

SkeletonLayout.propTypes = {
  showHeader: PropTypes.bool,
  showFooter: PropTypes.bool,
  blockCount: PropTypes.number,
  blockMinHeight: PropTypes.number,
};

export default SkeletonLayout;
